<template>
  <div class="student-bag navigation-top-app">
    <navigation-top-app
      :app="app"
      :menu-screen="app.user.role === 'student'"
      :back="() => {
        $router.push({name: 'app.student.profile', params: {code: app.user.code}, query: {origin: 'app', navigationLeft: 'false', token: app.token}})
      }"
    >
      <template v-slot:center>
        <div id="navigation-center">
          {{ app.strings.app.student.practice.bag.list.title }}
        </div>
      </template>
    </navigation-top-app>
    <transition name="fade">
      <div id="student-bag-content" class="max-width-800 margin-auto" v-if="show && !loading && bag.data.length > 0">
        <p class="bag-no-card" v-if="app.user.role === 'student' && !canBuy">{{ app.strings.app.student.practice.bag.list.no_card }}</p>
        <list :app="app">
          <template v-slot:rows>
            <div class="row" v-for="item in bag.data" v-bind:key="item.practice_type.id" :class="{danger: item.balance < 0}">
              <div>{{ item.practice_type.name | truncate(40) }}</div>
              <div class="right">
                <span class="badge">{{ item.balance }} {{ Math.abs(item.balance) === 1 ? app.strings.app.student.practice.bag.list.class : app.strings.app.student.practice.bag.list.classes }}</span>
              </div>
            </div>
          </template>
        </list>
      </div>
    </transition>
    <transition name="fade">
      <div id="student-bag-content" class="max-width-800 margin-auto empty" v-if="show && !loading && bag.data.length === 0">
        <div class="bag-empty">
          <font-awesome-icon :icon="['fas', 'shopping-bag']" />
          <div>{{ app.strings.app.student.practice.bag.list.empty }}</div>
          <button class="h-button default" v-if="app.user.role === 'student' && canBuy" v-on:click="buy()">{{ app.strings.app.student.practice.bag.list.buy }}</button>
          <p class="bag-no-card" v-if="app.user.role === 'student' && !canBuy">{{ app.strings.app.student.practice.bag.list.no_card }}</p>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div id="student-bag-content" v-if="show && loading">
        <loader-dot :size="'16px'" :color_1="'rgb(32, 113, 183)'" :color_2="'rgb(32, 113, 183)'" />
      </div>
    </transition>

    <div class="bottom-action" v-if="app.user.role === 'student' && canBuy && bag.data.length > 0">
      <button class="h-button w-100" v-on:click="buy()">{{ app.strings.app.student.practice.bag.list.buy }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-student-bag-list-view',
  data () {
    return {
      show: false,
      canBuy: false,
      bag: {
        loading: false,
        data: []
      }
    }
  },
  props: [
    'app'
  ],
  computed: {
    loading () {
      if (this.bag.loading) {
        return true
      }

      return false
    }
  },
  mounted () {
    this.show = true

    this.studentPracticeBagReadAll()
  },
  methods: {
    buy () {
      this.$router.push({name: 'app.student.practice.bag.shop', query: {origin: 'app', navigationLeft: 'false', token: this.app.token}})
    },
    studentPracticeBagReadAll () {
      if (this.bag.loading) {
        return
      }

      this.bag.loading = true

      this.$http.get(
        this.app.url.api + this.app.endpoints.student.practice.bag.read.all,
        {
          headers: {
            Authorization: 'Token ' + this.app.token
          }
        }
      ).then(response => {
        if (response.status === 200) {
          if (response.body.success === true) {
            this.bag.data = response.body.data.bag
            this.canBuy = response.body.data.can_buy
          } else {
            if (response.body.error.code === 'S100') {
              this.app.methods.logout()
            } else {
              this.showRequestError(this.app.strings, 'student-practice-bag-read', response.body.error)
            }
          }
        } else {
          this.showError(this.app.strings, 'request', 'status-' + response.status)
        }
        this.bag.loading = false
      }, () => {
        this.bag.loading = false
        this.showError(this.app.strings, 'request', 'status-network: Connection unreachable')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/variables-app.scss";
@import "@/assets/styles/variables-valkiria.scss";

#student-bag-content {
  position: relative;
  width: 100%;
  min-height: 100%;
  padding: 72px 0 96px;
  box-sizing: border-box;
}
#student-bag-content.empty {
  text-align: center;
}

.bag-no-card {
  margin: 0 0 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background-color: #f1f5f9;
  color: #475569;
  font-size: 14px;
  line-height: 1.4;
}

.bag-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-width: 420px;
  margin: 24px auto 0;
  padding: 28px 20px;
  border: 1px solid #e8edf3;
  border-radius: 20px;
  background-color: #FFFFFF;
  color: #64748b;
  font-size: 15px;
}

.bag-empty > svg {
  color: #94a3b8;
  font-size: 30px;
}

.bag-empty .h-button {
  width: auto;
  min-width: 200px;
}

@media (min-width: 1024px) {
  #student-bag-content {
    padding-top: 92px;
  }
}
</style>
